import { render, staticRenderFns } from "./diqu.vue?vue&type=template&id=24e33063&scoped=true&"
import script from "./diqu.vue?vue&type=script&lang=js&"
export * from "./diqu.vue?vue&type=script&lang=js&"
import style0 from "./diqu.vue?vue&type=style&index=0&id=24e33063&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e33063",
  null
  
)

export default component.exports